<template>
    <v-row justify="center">
        <v-dialog
                v-model="open"
                persistent
                max-width="400px"
                overlay-color="black"
                overlay-opacity="0.1"
        >
            <v-card style="background-color: #c8c8c8">
                <v-card-title>
                    <span class="text-h5" style="display: inline; font-weight: bolder">Upload CSV</span>
                    <span @click="close()" class="close">X</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <span class="prompt">Select the CSV format you wish to upload</span>
                            <v-select
                                    v-model="csvType"
                                    item-value="id"
                                    :items="csvTypes"
                                    solo
                                    dense
                                    hide-details
                                    dark
                                    id="cstSelect"
                                    base-color = "#3a3852"
                                    background-color="#3a3852"
                                    style="max-width:150px; margin-left: 75px; margin-top: 10px"
                            ></v-select>
                    </v-container>
                </v-card-text>
                <v-card-actions style="margin-left: 270px">
                    <label class="custom-file-upload">
                        <input type="file" accept=".csv" @change="handleFileUpload($event)"/>
                        UPLOAD
                    </label>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
    import Papa from 'papaparse';
    export default {
        props: {
            dialog: {
                type: Boolean,
                default: false
            },
            csvUploaded: {
                type: Function,
                default: () => null
            }
        },

        data() {
            return {
                open: this.dialog,
                csvTypes: ['Tipalti','Payoneer'],
                csvType: 'Tipalti',
                file: '',
                content: [],
                parsed: false
            }
        },

        async mounted() {},
        
        watch: {
            dialog() {
                this.open = this.dialog;
            }
        },

        methods: {
            handleFileUpload(event) {
                this.file = event.target.files[0];
                event.target.value = '';
                const self = this;
                Papa.parse( this.file, {
                    header: true,
                    skipEmptyLines: true,
                    complete: function( results ){
                        this.content = results;
                        this.parsed = true;
                        if (!results.errors.length) {
                            self.$emit('csvUploaded', {data: results.data, type: self.csvType, fields: results.meta.fields})
                        }

                    }.bind(this)
                } );
            },
            close() {
                this.$emit('update:dialog', false)
            }
        }
    }
</script>
<style scoped lang="sass">
    input[type="file"]
        display: none
    .custom-file-upload
        border: 1px solid #ccc
        display: inline-block
        padding: 6px 12px
        cursor: pointer
        background-color: var(--v-primary-base)
        color: white
        border-radius: 5px
        margin-bottom: 15px
    .close
        display: inline
        margin-left: 200px
        font-weight: bold
        font-size: 18px
        &:hover
            cursor: pointer
    span.prompt
        font-size: 14px !important
        margin-bottom: 15px !important
    div.container
        div.v-input
            div.v-input__control
                div[role="button"].v-input__slot
                    background-color: #3A3852!important
</style>